/**
 * selectionMotionSemantics
 *
 * Deterministic CSS properties for selection choreography across panes.
 * Communicates: selection focus, synchronized highlight, inspector transition.
 */

import { TRANSITION_BG_SELECTION, TRANSITION_ACCENT_SELECTION, TRANSITION_INSPECTOR_CONTENT } from './motionTokens.js';

export interface SelectionMotionStyle {
  transition: string;
  cursor: string;
}

/**
 * Row selection style for timeline, trace explorer, event log.
 * Soft elevation via background + left border accent.
 */
export function selectionRowStyle(isSelected: boolean, accentColor: string): React.CSSProperties {
  return {
    borderLeft: `2px solid ${isSelected ? accentColor : 'transparent'}`,
    backgroundColor: isSelected ? 'rgba(160, 160, 180, 0.08)' : 'transparent',
    transition: `${TRANSITION_BG_SELECTION}, ${TRANSITION_ACCENT_SELECTION}`,
    cursor: 'pointer',
  };
}

/**
 * Inspector content transition style.
 * Subtle fade when detail changes.
 */
export function inspectorContentStyle(detailKey: string | null): React.CSSProperties {
  return {
    opacity: detailKey ? 1 : 0.6,
    transition: TRANSITION_INSPECTOR_CONTENT,
  };
}

/**
 * Synchronized highlight indicator.
 * Used when a pane receives a synced selection from another pane.
 */
export function syncHighlightStyle(isSynced: boolean, accentColor: string): React.CSSProperties {
  return {
    boxShadow: isSynced ? `inset 3px 0 0 0 ${accentColor}` : 'none',
    transition: `box-shadow 80ms ease-out`,
  };
}
